import React, { Component } from 'react';
import GlobalSearch from "~/ui/GlobalSearch/GlobalSearch";
import { AboutUs } from '~/ui/AboutUs/AboutUs';

const appBarDialogs = {
    search: GlobalSearch,
    aboutUs: AboutUs
};

export const appBarDialogProps = {
    aboutUs: {
        className: AboutUs.dialogClassName,
    },
    search: {
        xs: {
            type: "fullscreen-auto",
            showCloseButton: true,
            marginTop: 0,
        },
        md: {

        },
    }
}

export default appBarDialogs;